import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import PrintButton from "./PrintButton";
import PersonalDetails from "./PersonalDetails";
import BankDetails from "./BankDetails";
import EducationDetails from "./EducationDetails";
import SignatureSection from "./SignatureSection";
import BankReciept from "./BankReciept";
import AddressDetails from "./AddressDetails";
import Signatures from "./Signatures";
import courses from "./courses";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";

const isAdmissionPage = window.location.toString().split("/")[4] == "admission";

const isDefinedCourse = isAdmissionPage
  ? courses.filter(
      (e) => e.code == window.location.toString().split("/")[5].toUpperCase()
    ).length > 0
  : false;

const edu_attachment =
  isAdmissionPage == false
    ? []
    : isDefinedCourse
    ? courses.filter(
        (e) => e.code == window.location.toString().split("/")[5].toUpperCase()
      ).length < 5
      ? ""
      : courses.filter(
          (e) =>
            e.code == window.location.toString().split("/")[5].toUpperCase()
        )[0].type === "UG"
      ? "UG"
      : "PG"
    : [];

// Header Component

const Header = ({

  data,
  collegeName,
  logoUrl,
  course,
  coursesList,
  session,
}) => {


  const selectedCourse = coursesList.find(
    (c) => c.name2.toLowerCase() === course.toLowerCase()
  );

  const courseCode = selectedCourse ? selectedCourse.code : "N/A";

  function formatNumber(num) {
    return num < 10 ? "0" + num : num.toString();
  }
  return (
    <div style={{ textAlign: "center" }}>
      <ul
        style={{
          listStyle: "none",
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
          alignItems: "center",
          width: "100%",
        }}
      >
        <li style={{ width: "15%" }}>
          <img
            src={logoUrl}
            style={{ height: "120px", width: "120px" }}
            alt="College Logo"
          />
        </li>
        <li style={{ width: "75%" }}>
          <h1>{collegeName}</h1>
        </li>
        <li style={{ width: "15%" }}>
          <img
            src={"https://vbsgdc.org.in/uploads/2023/05/Uttar_Pradesh.png"}
            style={{ height: "120px", width: "120px" }}
            alt="College Logo"
          />
        </li>
      </ul>
      <p style={{ fontSize: "16px", textAlign: "center" }}>
        <u>
          ADMISSION FOR THE COURSE OF {course} - First Year (Session: {session})
        </u>
      </p>

      <div>
        Code : {courseCode}/
        {data.part === "1"
          ? "First Year"
          : data.part === "2"
          ? "Second Year"
          : data.part === "3" && "Third Year"}
        /{formatNumber(data.id) || "N/A"}
      </div>
    </div>
  );
};

const AdditionalDetails = ({ data }) => {
  // Combine both arrays into one
  const allEligibilityItems = [
    ...(data.weightage || []),
    ...(data.horizontal_reservation || []),
  ];

  // Static list of all possible eligibility categories
  const eligibilityCategories = [
    "Disable Person(दिव्यांग)",
    "Freedom Fighter(स्वतंत्रता सेनानी पाल्य)",
    "Defense Person(प्रतिरक्षा कर्मचारी)",
    "N.C.C",
    "N.S.S",
    "Sports",
    "Scout",
  ];

  return (
    <div className="more-details" style={{ margin: "50px 0px 0px" }}>
      {allEligibilityItems.length > 0 ? (
        <>
          <p
            style={{
              textAlign: "center",
              backgroundColor: "#cb2b14",
              border: "1px solid",
              margin: "5px 0px",
              color: "white",
            }}
          >
            Eligibility Details
          </p>

          <ul
            style={{
              listStyle: "none",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              margin: "10px 0px",
            }}
          >
            <li style={{ width: "40%" }}>
              <ul>
                {eligibilityCategories.map((category) => (
                  <li key={category}>{category}</li>
                ))}
              </ul>
            </li>

            <li style={{ width: "60%" }}>
              <b>
                {eligibilityCategories.map((category) => {
                  const hasCategory = allEligibilityItems.some((item) =>
                    item
                      .toLowerCase()
                      .includes(category.toLowerCase().split("(")[0])
                  );

                  return (
                    <ul key={category}>
                      <li>{hasCategory ? "Yes" : "No"}</li>
                    </ul>
                  );
                })}
              </b>
            </li>
          </ul>
        </>
      ) : (
        <p style={{ textAlign: "center", color: "#666" }}>
          No eligibility details available
        </p>
      )}

      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <span>क्या आपकी पढ़ाई में कोई गैप है?</span>
        <span
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <label style={{ margin: "0px", marginRight: "10px" }}>हाँ</label>
            <input
              style={{ margin: "0px" }}
              checked={data.gap === "Yes"}
              type="checkbox"
            />
          </div>

          <div>
            <label style={{ margin: "0px", marginRight: "10px" }}>नहीं </label>
            <input
              style={{ margin: "0px" }}
              checked={data.gap === "No"}
              type="checkbox"
            />
          </div>
        </span>
      </div>
      <span style={{ color: "red" }}>
        {data.gap === "Yes" &&
          "(यदि हाँ, तो गैप प्रमाण पत्र (शपथ पत्र) जमा करें)"}
      </span>
    </div>
  );
};

const Declarations = ({ data }) => (
  <div style={{ padding: "20px" }}>
    <p style={{ textAlign: "center" }}>Declarations</p>
  </div>
);

const RequiredDocuments = ({ data, edu_attachment }) => {
  const newArr = [...new Set(data.attachments)];

  return (
    <div
      style={{ marginTop: "20px", border: "1px solid black", padding: "20px" }}
    >
      प्रवेश के समय सभी निम्न वॉछित प्रपत्रों की मूल प्रति लाना अनिवार्य है।
      <p>संलग्नक</p>
      <ol style={{ padding: "20px" }}>
        {newArr.map((item, idx) => (
          <li
            key={idx}
            style={{
              marginBottom: "10px",
              color: "#34495e",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            {item}
          </li>
        ))}
      </ol>
    </div>
  );
};

function AdmissionFormPrint() {


  // const contentRef = useRef(null);

  const [paymentStatus, setpaymentStatus] = useState("");

  const dateTime = String(paymentStatus.addedon);
  const [date, time] = dateTime.split(" ");

  const { id } = useParams();
  const [data, setData] = useState({});

  const loadResult = async () => {
    try {
      const printRes = await axios.post(
        "https://campus.acetians.in/api/v2/admission/print2",
        { admission_code: id }
      );
      setData(printRes.data[0]);
    } catch (error) {
      console.error("Error loading admission data:", error);
    }
  };

  useEffect(() => {
    loadResult();
  }, []);

  useEffect(() => {
    if (
      !data ||
      !Array.isArray(data.transactions) ||
      data.transactions.length === 0
    ) {
      setpaymentStatus("Pending");
    } else {
      const filtered = data.transactions.filter(
        (t) => t.amount > 50 && String(t.status).toLowerCase() === "success"
      );
      setpaymentStatus(
        filtered.length > 0 ? filtered[filtered.length - 1] : "Pending"
      );
    }
  }, [data]);

  if (!data || Object.keys(data).length === 0) {
    return <div>Loading...</div>;
  }

  const CouseCode = courses.filter((e) => e.name2 == data.course);

  return (
    <>
      <div
        style={{
          padding: "20px",
          maxWidth: "900px",
          margin: "auto",
          border: "1px solid black",
        }}
      >
        <PrintButton admissionId={id} />

        <Header
          CouseCode={CouseCode}
          data={data}
          coursesList={courses}
          collegeName="रघुवीर सिंह राजकीय महाविद्यालय, ललितपुर (उ.प्र.), नैक ग्रेड – बी"
          logoUrl="https://campus.acetians.in/custom/images/1722342842lalitpurlogo.png"
          course={`${data.course}`}
          session="2025-26"
        />

        <PersonalDetails data={data} />
        <EducationDetails data={data} edu_attachment={edu_attachment} />
        <AdditionalDetails data={data} />
        <Declarations data={data} />
        <SignatureSection data={data} />
        <Signatures date={date} data={data} />
        <RequiredDocuments edu_attachment={edu_attachment} data={data} />

        {/* <button onClick={() => console.log(data)}>hello</button> */}

        <div style={{ border: "1px solid black" }}>
          <div
            className="Print-chalan-page-content"
            style={{ padding: "20px" }}
          >
            <div className="Print-chalan-page-section">
              <h3 className="Print-chalan-page-section-title">
                Admission Payment Details
              </h3>

              <div className="Print-chalan-page-details">
                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">दिनांक:</p>
                  <p className="Print-chalan-detail-value">{date || "0"}</p>
                </div>

                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">
                    ऑनलाइन भुगतान संख्या:
                  </p>
                  <p className="Print-chalan-detail-value">
                    {/* {paymentStatus.txnid  || "0"} */}
                    {paymentStatus.txnid || "0"}
                  </p>
                </div>

                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">समय:</p>
                  <p className="Print-chalan-detail-value">{time || "0"}</p>
                </div>

                <div className="Print-chalan-page-detail-item">
                  <p className="Print-chalan-detail-label">
                    जमा किया गया शुल्क:
                  </p>
                  <p className="Print-chalan-detail-value">{`₹${data.fees}`}</p>
                </div>

              </div>
            </div>

            <div>
              {/* {student.courseType === "Renewal" && ( */}
              <div className="Chalan-page-auth">
                <ul></ul>
              </div>

              <span>Signature of Admission In-Charge</span>

              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdmissionFormPrint;
